import {computed, Injectable, signal} from '@angular/core';

// Minimal immutable snapshot of the authenticated user.
export interface UserSnapshot {
  id: string;
  name: string;
  roles: string[];
  token?: string | null;
}

@Injectable({ providedIn: 'root' })
// Store for user/auth snapshot as signals. Does not perform IO.
export class UserStore {
  private readonly _user = signal<UserSnapshot | null>(null);

  // getters (signals)
  readonly user = this._user.asReadonly();
  readonly isLoggedIn = computed(() => !!this._user()?.id);
  readonly roles = computed(() => this._user()?.roles ?? []);

  // setters
  setUser(u: UserSnapshot | null) { this._user.set(u); }
  setToken(token: string | null) { this._user.update(u => u ? ({...u, token}) : u); }
}


